'use client';

import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { IoPersonCircle } from "react-icons/io5";
import { getDecodedToken } from '../services/Token';

interface NavLink {
  name: string;
  path: string;
}

interface Props {
  links?: NavLink[];
}

const NavLinks = ({ name, path }: NavLink) => {
  const navigate = useNavigate();
  return (
    <MenuItem onClick={() => navigate(path)}>
      {name}
    </MenuItem>
  );
}
// TODO:arreglar navbar cuando es mas chico, no se pueden ver las opciones!! = navBarHome
export default function NavbarDashboard({ links = [] }: Props) { 
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const decoded = getDecodedToken();
  
  const handleLogout = () => {
    localStorage.removeItem('token'); 
    navigate('/login'); 
  };

  const getMenuItemsByRole = () => {
    if (!decoded) return [];
    if (decoded.rol_id === 1) { // SuperUser
      return [
        { name: 'Instituciones', path: '/dashboard/instituciones' },
        { name: 'Administradores', path: '/dashboard/administradores' },
        { name: 'Eventos', path: '/dashboard/eventos' },
        { name: 'Noticias', path: '/dashboard/noticias' }
      ];
    } else if (decoded.rol_id === 2) { // Admin
      return [
        { name: 'Carreras', path: '/dashboard/carreras' },
        { name: 'Eventos', path: '/dashboard/eventos' },
      ];
    }
    
    return [];
  };

  const roleLinks = getMenuItemsByRole();

  return (
    <Box bg={useColorModeValue('green.400', 'gray.900')} px={4}>
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
        <IconButton
          size={'md'}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={'Open Menu'}
          display={{ md: 'none' }}
          onClick={isOpen ? onClose : onOpen}
        />
        <HStack spacing={8} alignItems={'center'}>
          <Box>
            <Link href={"/"}>
              <img src="/logomunicipio.png" alt="Logo" width="40" height="40" />
            </Link>          
          </Box>
          <HStack as={'nav'} spacing={4} display={{ base: 'none', md: 'flex' }}>
            <Link href="/carreras" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Carreras
            </Link>
            <Link href="/instituciones" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Instituciones
            </Link>
            <Link href="/eventos" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Eventos
            </Link>
            <Link href="/info" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Calendario Educativo
            </Link>
            <Link href="/noticias" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Noticias
            </Link>
            <Link href="/decision" _hover={{ color: 'gray.300' }} color="white" fontWeight="medium">
              Toma de Decision
            </Link>
          </HStack>
        </HStack>

        <Flex alignItems={'center'} gap={4}>
          <Button
            onClick={() => navigate('/dashboard')}
            bg="green.600"
            color="gray.300"
            borderRadius="3xl"
            fontWeight="medium"
            _hover={{
              bg: 'green.700',
              color: 'red.500',
              transition: 'all 0.2s',
            }}
          >
            Panel de Control
          </Button>
          <Menu>
            <MenuButton
              as={Button}
              rounded={'full'}
              variant={'link'}
              cursor={'pointer'}
              minW={0}>
             <IoPersonCircle size={45} color='white'/>
            </MenuButton>
            <MenuList>
              {roleLinks.map((link) => (
                <NavLinks key={link.name} name={link.name} path={link.path} />
              ))}
              <MenuDivider />
              <MenuItem onClick={handleLogout} color="red">Cerrar Sesión</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
}
